import { useCallback, useEffect, useState } from 'react';
import {
  CollectionOptimisticActions,
  CollectionOptimisticActionsBaseParams,
  CollectionState,
} from '../state';
import { FiltersMap } from '../model';
import { useWixPatternsContainer } from '../providers';

export function useCreateOptimisticActions() {
  const container = useWixPatternsContainer();

  return useCallback(
    <T, F extends FiltersMap>(
      collection: CollectionState<T, F>,
      params?: Partial<CollectionOptimisticActionsBaseParams<T, F>>,
    ) =>
      collection._optimisticActions ??
      new CollectionOptimisticActions({
        container,
        collection,
        ...params,
      }),
    [],
  );
}

export function useOptimisticActions<T, F extends FiltersMap>(
  collection: CollectionState<T, F>,
  params?: Partial<CollectionOptimisticActionsBaseParams<T, F>>,
) {
  const createOptimisticActions = useCreateOptimisticActions();

  const [optimisticActions] = useState(() =>
    createOptimisticActions(collection, params),
  );

  useEffect(() => optimisticActions.init(), []);

  return optimisticActions;
}
